import { Link } from "react-router-dom";
import { MaskedLines, Reveal } from "@/components/aklive/motion";

export const HomeCTA = () => (
  <section className="py-24 md:py-40" data-testid="home-cta-section">
    <div className="container-ak">
      <h2 className="font-display text-5xl font-bold leading-[0.98] tracking-[-0.02em] text-ink sm:text-6xl lg:text-7xl">
        <MaskedLines
          lines={[
            "What are you",
            <span key="l2">
              building next<span className="text-ember">?</span>
            </span>,
          ]}
        />
      </h2>
      <Reveal delay={0.2} className="mt-8 md:mt-10">
        <p className="max-w-[560px] text-base leading-relaxed text-ink2 md:text-lg">
          Tell us where the business is headed. We'll help determine what needs to be built around it.
        </p>
      </Reveal>
      <Reveal delay={0.3} className="mt-10 flex flex-col items-start gap-6 sm:flex-row sm:items-center md:mt-14">
        <Link to="/contact" data-testid="home-cta-start-btn" className="btn-primary h-14 px-8 text-base">
          Start a Project
        </Link>
        <a
          href="mailto:connect@aklive.studio"
          data-testid="home-cta-email-link"
          className="link-underline flex min-h-[44px] items-center font-display text-lg font-bold tracking-tight text-ink hover:text-ember"
        >
          connect@aklive.studio
        </a>
      </Reveal>
    </div>
  </section>
);
